import { createSlice, createEntityAdapter } from "@reduxjs/toolkit";
import { authFailCheck } from "./auth.slice";
import LessonTimeService from "services/LessonTimeService";

const lessonTimesAdapter = createEntityAdapter({
  selectId: (item) => item.id,
});

const lessonTimesSlice = createSlice({
  name: "lessonTimes",
  initialState: lessonTimesAdapter.getInitialState({
    isLoading: false,
  }),
  reducers: {
    fetchRequest(state) {
      state.isLoading = true;
    },
    fetchFail(state) {
      state.isLoading = false;
    },
    fetchLessonTimesSuccess(state, action) {
      state.isLoading = false;
      lessonTimesAdapter.setAll(state, action.payload);
    },
    createLessonTimeSuccess(state, action) {
      state.isLoading = false;
      lessonTimesAdapter.addOne(state, action.payload);
    },
    updateLessonTimeSuccess(state, action) {
      state.isLoading = false;
      lessonTimesAdapter.upsertOne(state, action.payload);
    },
    deleteLessonTimeSuccess(state, action) {
      state.isLoading = false;
      lessonTimesAdapter.removeOne(state, action.payload);
    },
  },
});

export const lessonTimesSelectors = lessonTimesAdapter.getSelectors((state) => state.lessonTimes);

export default lessonTimesSlice.reducer;

export const fetchLessonTimes = () => async (dispatch) => {
  dispatch(lessonTimesSlice.actions.fetchRequest());
  const response = await LessonTimeService.get();
  if (response.ok) {
    dispatch(lessonTimesSlice.actions.fetchLessonTimesSuccess(response.data));
  } else {
    dispatch(authFailCheck(response));
    dispatch(lessonTimesSlice.actions.fetchFail());
  }
};

export const createLessonTime = (data) => async (dispatch) => {
  dispatch(lessonTimesSlice.actions.fetchRequest());
  const response = await LessonTimeService.create(data);
  if (response.ok) {
    dispatch(fetchLessonTimes());
    return { ok: true };
  } else {
    dispatch(authFailCheck(response));
    dispatch(lessonTimesSlice.actions.fetchFail());
    return { ok: false, message: response.data?.message };
  }
};

export const updateLessonTime = (id, data) => async (dispatch) => {
  dispatch(lessonTimesSlice.actions.fetchRequest());
  const response = await LessonTimeService.update(id, data);
  if (response.ok) {
    dispatch(fetchLessonTimes());
    return { ok: true };
  } else {
    dispatch(authFailCheck(response));
    dispatch(lessonTimesSlice.actions.fetchFail());
    return { ok: false, message: response.data?.message };
  }
};

export const deleteLessonTime = (id) => async (dispatch) => {
  dispatch(lessonTimesSlice.actions.fetchRequest());
  const response = await LessonTimeService.delete(id);
  if (response.ok) {
    dispatch(lessonTimesSlice.actions.deleteLessonTimeSuccess(id));
  } else {
    dispatch(authFailCheck(response));
    dispatch(lessonTimesSlice.actions.fetchFail());
  }
};
